'use client'

import * as Devtools from './ReactQueryDevtools'
import * as DevtoolsPanel from './ReactQueryDevtoolsPanel'

export const ReactQueryDevtools = Devtools.ReactQueryDevtools
export const ReactQueryDevtoolsPanel = DevtoolsPanel.ReactQueryDevtoolsPanel
